import { render, staticRenderFns } from "./AlertMapHeader.vue?vue&type=template&id=65c47fb8&"
import script from "./AlertMapHeader.vue?vue&type=script&lang=js&"
export * from "./AlertMapHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports